import React from 'react';
import BasicModal from './BasicModal';
import icon_delete from 'images/new_pop_ups/delete.svg';

const DeleteModal = (props) => {
    let modalTypes = {
        deleteProject: {
            title: 'Delete Project',
            description:
                'This will delete the dataframe and all <br />analyses. Are you sure you want to delete?'
        },
        deleteDataset: {
            title: 'Delete Dataset',
            description:
                'This will delete the dataset, all projects <br />and analyses. Are you sure you want to delete?'
        },
        deleteAnalysis: {
            title: 'Delete Analysis',
            description:
                'This will delete the analysis. Are you sure you want to delete?'
        },
        deleteColumn: {
            title: 'Delete Column',
            description: 'This will delete the selected column.'
        }
    };
    return (
        <>
            <BasicModal
                title={modalTypes[props.modalType].title}
                visible={props.visible}
                onCancel={props.onCancel}
                icon={icon_delete}
                onAcceptTitle="Delete"
                onAcceptClassName="red-button"
                onAccept={props.onAccept}
            >
                <div>
                    <div>
                        <p
                            className="p-desctiption"
                            style={{ height: 380, marginBottom: '-223px' }}
                            dangerouslySetInnerHTML={{
                                __html: modalTypes[props.modalType].description
                            }}
                        ></p>
                    </div>
                </div>
            </BasicModal>
        </>
    );
};

export default DeleteModal;
